import { Component, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { ServiceNames, WS10UploadModel } from '@vfde-fe/ngx-lib/brix/ws10-upload';
import { SharedDataTriggerService } from 'src/app/shared/services/shared-data-in-form-center/shared-data-trigger.service';

/** UploadComponent */
@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
})
export class UploadComponent implements OnInit {
  /** ServiceName */
  public ServiceName = ServiceNames;
  /** deWordingPath */
  public deWordingPath: string;
  /** uploadProperties */
  public uploadProperties: WS10UploadModel;
  /** uploadFileVisibility */
  public uploadFileVisibility: boolean;

  /**
   * constructor
   * @param ts TranslateService
   */
  public constructor (
    public ts: TranslateService,
    public uploadService: SharedDataTriggerService,
  ) {}
  public ngOnInit (): void {
    this.deWordingPath = 'FromCenterModule.formSubmit.formUpload.';
    this.setHeaderObject();
    this.callObservableTrigger();
  }

  /**
   * callObservableTrigger
   * @description handle visibility of upload component based on status
   */
  private callObservableTrigger (): void{
    // Subscribe to upload visible status changes
    this.uploadService.uploadVisibleStatus$.subscribe((status: boolean) => {
     this.uploadFileVisibility = status;
   });
  }

  /**
   * checkUploadStatus
   * @description check upload returned from ngx for uploading and call services
   * @param status boolean
   */
  public checkUploadStatus (status: boolean){
    // Call the service to update the status from ngx
    this.uploadService.updateUploadStatus(status);

  }
  /**
   * setUploadedFiles
   * @description chack upload returned from ngx for uploading and call services
   * @param file boolean
   */
  public setUploadedFiles (file: any){
    // Call the service to update the file from ngx
    this.uploadService.sharedUploadedFiles(file);

  }


  /** setSearchBar
   *  @returns void
   */
  public setHeaderObject (): void {

    this.uploadProperties = {
      stdHeadline: this.ts.instant(this.deWordingPath + 'std-headline'),
      stdSubHeadline: this.ts.instant(this.deWordingPath + 'std-subHeadline'),
      containerButton: {
        color: this.ts.instant(this.deWordingPath + 'containerButton.color.std-headline'),
        content: this.ts.instant(this.deWordingPath + 'containerButton.content.std-headline'),
        widthVariation: this.ts.instant(this.deWordingPath + 'containerButton.widthVariation.std-headline'),
        size: this.ts.instant(this.deWordingPath + 'containerButton.size.std-headline'),
        icon: {
          position: this.ts.instant(this.deWordingPath + 'containerButton.icon.position.std-headline'),
          imgIconSrc: this.ts.instant(this.deWordingPath + 'containerButton.icon.imgIconSrc.std-headline'),
          iconColor: this.ts.instant(this.deWordingPath + 'containerButton.icon.iconColor.std-headline'),
          iconSize: this.ts.instant(this.deWordingPath + 'containerButton.icon.iconSize.std-headline'),
          iconBrix: this.ts.instant(this.deWordingPath + 'containerButton.icon.iconBrix.std-headline'),
        },
      },
      containerFormTextInput: {
        type: this.ts.instant(this.deWordingPath + 'containerFormTextInput.type.std-headline'),
        isDisabled: this.ts.instant(this.deWordingPath + 'containerFormTextInput.isDisabled.std-headline'),
        id: this.ts.instant(this.deWordingPath + 'containerFormTextInput.id.std-headline'),
        name: this.ts.instant(this.deWordingPath + 'containerFormTextInput.name.std-headline'),
        placeholder: this.ts.instant(this.deWordingPath + 'containerFormTextInput.placeholder.std-headline'),
        automation_id: this.ts.instant(this.deWordingPath + 'containerFormTextInput.automationId.std-headline'),
      },
      uploadError: this.ts.instant(this.deWordingPath + 'uploadError.std-headline'),
      virusScanError: this.ts.instant(this.deWordingPath + 'virusScanError.std-headline'),
      serviceName: this.ServiceName.FORM_CENTER_UPLOAD,
      waitingTime: this.ts.instant(this.deWordingPath + 'waitingTime.text-body'),
      };
}

}
